import { useI18n } from 'domains/i18n/hooks'
import { className } from 'lib/css'
import CardComponent from 'ui/components/conversation/event/card-component'

export default function CarouselMessageSlide({
  item: slide,
  items,
  index,
  isActive,
}) {
  const { t } = useI18n()
  return (
    <div
      className={className('carousel-item', `carousel-item--${slide.type}`)}
      role="group"
      aria-roledescription="slide"
      aria-label={t('carousel.slide.label', {
        index: index + 1,
        total: items.length,
      })}
    >
      <CardComponent {...slide} isCarouselItem={true} hasFocus={isActive} />
    </div>
  )
}
